export const paginationOptions = [100, 300, 500, 1000, 3000, 5000, 'All', 'Custom'];
//# sourceMappingURL=constants.js.map